export default __webpack_public_path__ + "static/media/MBB.54c6f2a2.svg";